<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div class="label d-flex justify-content-between">
    <span>
      {{ 'TIMEZONE_SELECT.TIMEZONE' | translate }}
    </span>
  </div>

  <ng-select [items]="data" [loading]="loader" [formControlName]="'timezone'">
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
      </div>
    </ng-template>
  </ng-select>
</div>
